<!-- <main>
    <section class="container" id="legislacao">
        <h1 class="title" *ngIf="legislacoes">Legislação</h1>
        <hr class="bg-color-dark-grey hr-line" />
        <div class="legislacao-container" *ngFor="let legislacao of legislacoes">
            <p>
                {{ legislacao.mensagem }}
            </p>
            <a href="{{ legislacao.link }}" target="_blank" rel="noreferrer" class="negrito link custom-link">{{
                legislacao.nome }}</a> - {{ legislacao.descricao }}
        </div>
    </section>
</main> -->

<main>
    <section class="container" id="legislacao">
        <h1 class="title" *ngIf="legislacoes">Legislação</h1>
        <hr class="bg-color-dark-grey hr-line" />
        <div class="text">
            <div *ngFor="let legislacao of legislacoes">
                <p class="padding" *ngIf="legislacao.mensagem">
                    {{ legislacao.mensagem }}
                </p>
                <p class="padding">
                    <a href="{{ legislacao.link }}" target="_blank" rel="noreferrer" class="link custom-link">{{
                        legislacao.nome }}</a> - {{ legislacao.descricao }}
                </p>
            </div>
        </div>
    </section>
</main>